<template>
<div class="fireHydrant">
  <el-drawer title="水压设备详情" size="600px" :modal="false" :visible.sync="datailsShow" :wrapperClosable="false" direction="rtl" ref="drawer">
    <device-details-drawer v-if="datailsShow" :datailsData="details"></device-details-drawer>
  </el-drawer>
  <div class="mainContent" :style="styleObject">
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
        <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <div class="container">
      <div class="query">
        <span>
          <el-input placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText" style="width:200px;"></el-input>
          <el-select v-model="keyWords.isInstall" placeholder="是否安装" style="padding: 5px 0" clearable @change="changeRadio2" @clear="clearRadio2">
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select v-model="keyWords.isRegist" placeholder="是否注册" clearable>
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <el-select v-model="keyWords.isOnline" placeholder="是否在线" clearable>
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select v-model="keyWords.isFault" placeholder="是否故障" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </span>
        <button class="primaryBtn" v-if="rolePermit('device:electrical:query')" @click="searchData">搜索</button>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]"  :pages="pagination" :loading="tableLoading" @selectionChange="handleSelectionChange" :current-page="pagination.page" @currentChange="electricalCurrentChange" @sizeChange="electricalSizeChange">
        <el-table-column prop="name" label="设备名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="imei" label="IMEI" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="deviceId" label="设备ID" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="typeName" label="设备类型名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isOnline" label="在线状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isRegist" label="注册状态" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="registType" label="注册类型" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="isInstall" label="安装状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isEnabled" label="是否启用" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isAlarm" label="报警状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isFault" label="是否故障" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="installLocation" label="安装位置" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="installGps" label="经纬度" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="hardwareVersion" label="硬件版本号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="serviceID" label="服务号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="softwareVersion" label="软件版本" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="iccid" label="集成电路卡识别码" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="preLowWaterPressureEnable" label="阀门前低水压使能" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="preHighWaterPressureEnable" label="阀门前高水压使能" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="preFluctuateEnable" label="阀门前波动使能" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="preLowWaterPressureLimit" label="阀门前低水压门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="preHighWaterPressureLimit" label="阀门前高水压门限值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="preFluctuateLimit" label="阀门前波动门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aftLowWaterPressureEnable" label="阀门后低水压使能" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aftHighWaterPressureEnable" label="阀门后高水压使能" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aftFluctuateEnable" label="阀门后波动使能" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="aftLowWaterPressureLimit" label="阀门后低水压门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aftHighWaterPressureLimit" label="阀门后高水压门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aftFluctuateLimit" label="阀门后波动门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tempEnable" label="设备温度监测使能开关" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lowTempLimit" label="设备温度低温门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="highTempLimit" label="设备温度高温门限值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="tempWaterEnable" label="设备温度监测使能开关" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lowTempWaterLimit" label="设备温度低温门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="highTempWaterLimit" label="设备温度高温门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="inclineEnable" label="柱体倾斜监测使能开关" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="collisionEnable" label="柱体碰撞监测使能开关" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="inclineLimit" label="柱体倾斜门限值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="collisionSensitivity" label="柱体碰撞灵敏度" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="batLowPowerLimit" label="电池低电量门限值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="locStatus" label="定位状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.locStatus == 0 ? '定位失败' : scope.row.locStatus == 1 ? '定位成功' : '正在定位'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="longitude" label="经度" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="latitude" label="纬度" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sensorsName" label="支持的传感器名称" :show-overflow-tooltip="true"></el-table-column>

        <!-- <el-table-column prop="devStatus" label="设备状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.devStatus == 1 ? '报警' : '正常'}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="devStatusDes" label="设备状态描述" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="devFaultStatus" label="故障状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.devFaultStatus == 1 ? '故障' : '正常'}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="devFaultStatusDes" label="故障状态描述" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="preWaterPressure" label="阀门前水压" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aftWaterPressure" label="阀门后水压" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="devTmep" label="设备温度" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="waterTmep" label="水温度" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="batQuantity" label="电池电量百分比" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="voltage" label="电池电压" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="incline" label="倾斜角度" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="signalECL" label="信号覆盖等级" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="RSRP" label="信号接收功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="SNR" label="信噪比" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="powerLevel" label="接收功率强度等级" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="valveStatus" label="阀门状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.valveStatus == 0 ? '关闭' : '打开'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="intakingWay" label="取水方式" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.intakingWay == 0 ? '刷卡取水' : scope.row.intakingWay == 1 ? '无卡常规取水' : scope.row.intakingWay == 2 ? '无卡消防取水' : scope.row.intakingWay == 3 ? '无卡应急取水' : '非法用水'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ICCode" label="IC卡卡号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="intakingTime" label="取水时长/s" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="intakingTotal" label="取水量/L" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="intakingInstant" label="瞬时流量m3/h" :show-overflow-tooltip="true"></el-table-column>

        <!-- <el-table-column prop="ts8" label="通道8开关标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ta8" label="通道8报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tf8" label="通道8故障标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tt8" label="通道8类型" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tv8" label="通道8值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="ts9" label="通道9开关标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ta9" label="通道9报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tf9" label="通道9故障标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tt9" label="通道9类型" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tv9" label="通道9值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="ts10" label="通道10开关标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ta10" label="通道10报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tf10" label="通道10故障标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tt10" label="通道10类型" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tv10" label="通道10值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="ts11" label="通道11开关标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ta11" label="通道11报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tf11" label="通道11故障标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tt11" label="通道11类型" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tv11" label="通道11值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="tef" label="断电故障标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tva" label="A相电压报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tvb" label="B相电压报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tvc" label="C相电压报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tia" label="A相电流报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tib" label="B相电流报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tic" label="C相电流报警标志" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phaseVa" label="相电压Va" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phaseVb" label="相电压Vb" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phaseVc" label="相电压Vc" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lineUab" label="线电压Uab" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lineUbc" label="线电压Ubc" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="lineUca" label="线电压Uca" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phaseIa" label="相电流Ia" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phaseIb" label="相电流Ib" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phaseIc" label="相电流Ic" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="pa" label="A相有功功率" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="pb" label="B相有功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="pc" label="C相有功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="qa" label="A无功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="qb" label="B无功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="qc" label="C无功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sa" label="A视在功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sb" label="B视在功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sc" label="C视在功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="allp" label="总有功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="allq" label="总无功功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="alls" label="总视在功率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="alle" label="总电量" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="gridFrequency" label="电网频率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="powerfactorA" label="A功率因数" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="powerfactorB" label="B功率因数" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="powerfactorC" label="C功率因数" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="connectionmode" label="接线方式" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="vaTs" label="A相电压开关状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="vbTs" label="B相电压开关状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="vcTs" label="C相电压开关状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="iaTs" label="A相电流开关状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ibTs" label="B相电流开关状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="icTs" label="C相电流开关状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ovsetvalue" label="过压报警设定值" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="uvsetvalue" label="欠压报警设定值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="oiasetvalue" label="A相过流设定值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="oibsetvalue" label="B相过流设定值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="oicsetvalue" label="C相过流设定值" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="iaCTmag" label="A相电流CT倍率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ibCTmag" label="B相电流CT倍率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="icCTmag" label="C相电流CT倍率" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="buzzerState" label="BuzzerState蜂鸣器状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="outState" label="OutState输出状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="inState" label="InState输入状态" :show-overflow-tooltip="true"></el-table-column> -->

        <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="" label="操作" width="200px" v-if="rolePermit('device:electrical:del')||rolePermit('device:electrical:query')">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-delete" v-if="rolePermit('device:electrical:del')" @click="delClick(scope.row)">删除</el-button>
            <el-button type="text" icon="el-icon-reading" v-if="rolePermit('device:electrical:query')" @click="detailClick(scope.row)">详情</el-button>
          </template>
        </el-table-column> -->
      </border-table>
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import DeviceDetailsDrawer from "@/components/deviceElectrical/DeviceWaterLiquid";

export default {
  components: {
    BorderTable,
    DeviceDetailsDrawer
  },
  data() {
    return {
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
       deviceTypeList: [],
      radio1: "0",
      treeData: [],
      currentTreeId: 0,
      selectedName: "",
      names: "",
      styleObject: {
        height: ""
      },
      tableLoading: false,
      checkDatas: [],
      dataList: [],
      details: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      drawerTitle: "",
      drawerWidth: "500px",
      handleType: '',
      selectData: {},
      isInstall: '',
      // isRegist: true,
      nodisabled1: false,
      content: '',
      searchText: '',
      datailsShow: false,
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
    }
  },
  created() {
    this.makeheight();
    // this.reloadTable();
    // this.queryTreeNode()
  },
  methods: {
    async getDeviceType() {
      const {
        data,
        code,
        msg
      } = await this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      })
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.deviceTypeList = data.data
      console.log(`data`, data)
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       console.log(rs);

    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.reloadTable()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.reloadTable()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    searchData() {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    electricalCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloadTable();
    },
    //表格展示条数变化时
    electricalSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    reloadTable() {
      this.params = {
        "key": this.searchText,
        "page": this.pagination.currentPage,
        "pageSize": this.pagination.pageSize,
        "orgId": this.currentTreeId?this.currentTreeId:0,
        // "isRegist": this.isRegist,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }

      let url = this.params.orgId == -1 ? '/front/device/pressure/queryOutbound' : '/front/device/fireHydrant/query'

      this.request.get(url, this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.dataList = res.data?res.data:[]
            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
      this.dataList = []
    },
    formatDate(d) {
      let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return d.getFullYear() + "-" + month + "-" + day;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    changeRadio1() {
      this.nodisabled1 = false
      this.isInstall = false
      this.pagination.currentPage = 1;
      // this.searchText = ''
      //已注册
      this.reloadTable();
    },
    // changeRadio2() {
    //   this.nodisabled1 = true
    //   this.isRegist = ''
    //   this.pagination.currentPage = 1;
    //   // this.searchText = ''
    //   //已安装
    //   this.reloadTable();
    // },
    clearRadio2(data){
      this.nodisabled1 = false
      this.nodisabled2 = true
      this.isInstall = false
      this.isRegist = ''
      this.pagination.currentPage = 1;
    },
    changeRadio2(data) {
      this.nodisabled1 = !!data
      this.isInstall = !!data
      // if(data){
      //   this.nodisabled1 = true
      //   this.isInstall = true
      // }else{
      //   this.nodisabled1 = false        
      //   this.isInstall = false   
      // }
      this.nodisabled2 = true
      this.isRegist = ''
      this.pagination.currentPage = 1;
      // this.searchText = ''
      //已安装
      // this.initData();
    },
    changeRadio3() {
      this.nodisabled1 = false
      this.isInstall = false
      this.pagination.currentPage = 1;
      //未注册
      this.reloadTable();
    },
    delBath() {
      //批量删除
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选删除内容！")
      } else {
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push(this.checkDatas[i].deviceId)
        }
        this.arry = arr
        console.log(this.arry)
        let params = {
          deviceIds: this.arry.toString()
        }
        this.$confirm('此操作将永久删除内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.request.delete("/front/device/electrical", params).then(res => {
            // console.log(res)
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              let num = ''
              if (this.pagination.total > this.pagination.pageSize) {
                num = (this.pagination.total - this.checkDatas.length) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.reloadTable()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    handleSelectionChange(data) { //多选
      // console.log(data)
      this.checkDatas = data
    },
    delClick(row) {
      //删除
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.delete("/front/device/electrical?deviceIds=" + row.deviceId).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              let num = ''
              if (this.pagination.total > 1) {
                num = (this.pagination.total - 1) % this.pagination.pageSize
                if (num === 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.reloadTable()
            } else if (res.code === 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    detailClick(row) { //详情
      this.request.get("/front/device/fireHydrant/" + row.deviceId).then((res) => {
        if (res.code === 200) {
          this.details = res.data
          this.datailsShow = true
        } else if (res.code === 500) {
          this.msg.warn(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fireHydrant {
  position: relative;

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .container {
      padding-left: 260px;
    }

    .query {
      margin-bottom: 20px;
    }

    .radio {
      font-size: 0;
      margin: 20px 0;

    /*   .noEquipment {
        font-size: 14px;
        font-weight: 400;
        color: #606266;
      } */

      .line {
        font-size: 20px;
        font-weight: 100;
        color: #606266;
        margin-right: 25px;
      }
    }

    .del {
      background: #ff0000;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }

    .btnS {
      color: #fff;
      border: 1px solid #a1c6f3;
      background: #2177E6;
      margin-right: 24px;

      &.active {
        border: 1px solid #F2F2F2;
        background: #F2F2F2;
        color: #AAAAAA;
        cursor: default;
      }
    }
  }
}
</style><style lang="scss">
.fireHydrant {
  .treeAside {
    position: absolute;
    width: 300px;
    height: 100%;
    padding: 15px 20px;
    left: 0;
    top: 0;
    box-sizing: border-box;

    .treeTop {
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 0;
      font-weight: bold;
      top: 20px;
      z-index: 10;
      // left: 30px;
      padding-left: 10px;

      .treeTopTitle {
        margin-right: 115px;
        // width: 500px;
        font-size: 18px;
        color: #333;
      }

      .el-button {
        margin-left: -24px;
      }

      .complete {
        margin-left: 10px;
      }
    }

    .treeBox {
      overflow: hidden;
      height: 100%;
      border: 1px solid #ebeef5;
      padding: 40px 0 10px;
      box-sizing: border-box;
    }

    .tree {
      height: 100%;
      overflow: auto;

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        height: 40px;
        line-height: 40px;
        width: 100%;

        .treeLabel {
          font-size: 14px;
          display: inline-block;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .treeBtn {
          float: right;

          .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .query {
    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }
}

.exportBtn {
  background: #2177E6;
  color: #fff;
  padding: 11px 15px;
  height: 36px;
  line-height: 36px;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
}
</style>
